import $ from 'jquery';

$(() => {
    $('.js_template_delete').on('click', e => {
        e.preventDefault();

        const $target = $(e.currentTarget);
        if(confirm('本当に削除しますか？')){
            $target.parents('form').submit();
        }
    });
    $('.js_list_delete').on('click', e => {
        e.preventDefault();

        const $target = $(e.currentTarget);
        if(confirm('本当に削除しますか？')){
            $target.parents('form').submit();
        }
    });
});
